import { render, staticRenderFns } from "./ColourLogic.vue?vue&type=template&id=592f5a10&scoped=true&"
import script from "./ColourLogic.vue?vue&type=script&lang=ts&"
export * from "./ColourLogic.vue?vue&type=script&lang=ts&"
import style0 from "./ColourLogic.vue?vue&type=style&index=0&id=592f5a10&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f5a10",
  null
  
)

export default component.exports